import Vue from 'vue'

export default class API {
    getTransactions(period) {
        return Vue.axios.get('/api/v1/transactions?period=' + period)
    }

    getNews() {
        return Vue.axios.get('/api/v1/news')
    }

    getDevices() {
        return Vue.axios.get('/api/v1/devices')
    }

    getReferrals() {
        return Vue.axios.get('/api/v1/referrals')
    }

    getStatistics(period) {
        return Vue.axios.get('/api/v1/profile/statistics?days=' + period)
    }

    inviteFriend(email) {
        return Vue.axios.post('/api/v1/invite', {
            email
        })
    }

    requestPayout(gateway, amount) {
        return Vue.axios.post('/api/v1/transactions', {
            gateway, amount
        })
    }

    requestPasswordReset(email) {
        return Vue.axios.post('/api/v1/passwords/', {
            email
        })
    }

    changePassword(password, token) {
        return Vue.axios.post('/api/v1/passwords/confirm/', {
            password, token
        })
    }

    updatePassword(password, new_password) {
        return Vue.axios.patch('/api/v1/profile', {
            password, new_password
        })
    }

    updateNotifications(data) {
        return Vue.axios.patch('/api/v1/profile', data)
    }

    updatePayment(data) {
        return Vue.axios.patch('/api/v1/profile', data)
    }

    contactUs(name, email, message) {
        return Vue.axios.post('/api/v1/contact-us', {
            name, email, message
        })
    }

    getClients({countries = [], versions = [], limit = 50, offset = 0}) {
        let uri = '/api/v1/clients?'
        const args = []
        if (countries.length > 0) {
            args.push('country=' + countries.join(','))
        }

        if (versions.length > 0) {
            args.push('version=' + versions.join(','))
        }

        args.push('limit=' + limit)
        args.push('offset=' + offset)

        uri = uri + args.join('&')

        return Vue.axios.get(uri)
    }

    getClientsCountryStats() {
        return Vue.axios.get('/api/v1/clients/countries')
    }

    getClientsPoolStats() {
        return Vue.axios.get('/api/v1/clients/pools')
    }
}
